import { Component, Input } from '@angular/core';
import Debug from 'debug';
import { IExtraActionFooterButton } from '../../interfaces/IExtraActionFooterButton.interface';
const debug = Debug('aumico:AumActionBarPure');
@Component({
    selector: 'aum-action-bar-pure',
    styleUrls: ['./action-bar.scss'],
    templateUrl: './action-bar.html',
})
export class AumActionBarPure {
    @Input() backButtonText?: string;
    @Input() backButtonPrefixText?: string;
    @Input() backButtonIcon?: string;
    @Input() backButtonRouterLink?: [];
    @Input() backButtonAction?: () => {} = async () => debug('backButtonAction not implemented');

    @Input() nextButtonText?: string;
    @Input() nextButtonPrefixText?: string;
    @Input() nextButtonRouterLink?: [];
    @Input() nextButtonDisabled: true;
    @Input() nextButtonAction?: () => {} = async () => debug('nextButtonAction not implemented');

    @Input() actionButtonText?: string;
    @Input() actionButtonRouterLink?: [];
    @Input() actionButtonDisabled: true;
    @Input() actionButtonAction?: () => {} = async () => debug('actionButtonAction not implemented');

    @Input() extraActionButtons?: IExtraActionFooterButton[];
}
